// extracted by mini-css-extract-plugin
export default {"archive":"styles_archive__U-ROy","active":"styles_active__6Pj+q","icon":"styles_icon__jVYNG"};